import PasswordFeedback from './PasswordFeedback';

export default PasswordFeedback;
export type { PasswordFeedbackProps } from './PasswordFeedback';
